import React from 'react';
import { Route } from 'react-router-dom';
import { Routes } from './Routes';
export const routes = [<Route key={0} path="/mail" component={Routes} />];

export const navigation = { name: `mail`, link: '/mail', parent: 'BoardMembers' };
